/**
 * Brazilian Portuguese (pt-BR) translations for Onboarding Tour
 */

export const onboardingPtBR = {
  // Step titles
  'Welcome to PickStar AI': 'Bem-vindo ao PickStar AI',
  'Live Trending Games': 'Jogos Ao Vivo em Destaque',
  'Quick Actions': 'Ações Rápidas',
  'QuickPicks - Fast AI Predictions': 'QuickPicks - Previsões Rápidas com IA',
  'Deep Analysis with AI': 'Análise Profunda com IA',
  'Your Chat History': 'Seu Histórico de Conversas',
  'Ready to Start': 'Pronto para Começar',

  // Step content
  'Your intelligent sports betting assistant. Let me show you around the platform and its powerful features.':
    'Seu assistente inteligente de apostas esportivas. Deixe-me mostrar a plataforma e seus recursos poderosos.',

  'Live Trending Games - More games can be found at our data hub for quick picks.':
    'Jogos Ao Vivo em Destaque - Mais jogos podem ser encontrados em nosso centro de dados para escolhas rápidas.',

  'Access key features instantly. Start new chats, get quick picks, buy coins, view market insights, check sports hub, and browse active games.':
    'Acesse recursos principais instantaneamente. Inicie novos chats, obtenha escolhas rápidas, compre moedas, veja insights de mercado, verifique o hub esportivo e navegue pelos jogos ativos.',

  'Get instant AI-powered betting predictions with confidence scores. Our advanced algorithms analyze real-time data to provide you with the best picks.':
    'Obtenha previsões de apostas instantâneas com IA e pontuações de confiança. Nossos algoritmos avançados analisam dados em tempo real para fornecer as melhores escolhas.',

  'Start a new chat to get detailed betting analysis, or continue from your history. Ask anything about sports, odds, strategies, and get expert AI insights.':
    'Inicie um novo chat para obter análise detalhada de apostas, ou continue do seu histórico. Pergunte qualquer coisa sobre esportes, odds, estratégias e obtenha insights especializados de IA.',

  'Access your previous conversations and analyses. Review past predictions, continue discussions, and track your betting insights over time.':
    'Acesse suas conversas e análises anteriores. Revise previsões passadas, continue discussões e acompanhe seus insights de apostas ao longo do tempo.',

  'You are all set to explore PickStar AI. Make informed betting decisions with our AI-powered insights and comprehensive sports analysis.':
    'Você está pronto para explorar o PickStar AI. Tome decisões de apostas informadas com nossos insights baseados em IA e análise esportiva abrangente.',

  // Navigation buttons
  'Back': 'Voltar',
  'Next': 'Próximo',
  'Get Started': 'Começar',
  'Skip tour': 'Pular tour',
  'Tour': 'Tour',

  // Progress indicator
  'Step': 'Passo',

  // Quick Actions translations
  'New Chat': 'Novo Chat',
  'Ask your AI assistant': 'Pergunte ao seu assistente IA',
  'QuickPicks': 'Escolhas Rápidas',
  'Fast AI predictions': 'Previsões rápidas com IA',
  'Buy Coins': 'Comprar Moedas',
  'Get StarCoins for premium': 'Obtenha StarCoins para premium',
  'AI Exchange': 'Bolsa IA',
  'Market insights & trends': 'Insights e tendências de mercado',
  'Sports Hub': 'Hub Esportivo',
  'Live stats & predictions': 'Estatísticas e previsões ao vivo',
  'Market View': 'Visão do Mercado',
  'Browse active games': 'Navegue pelos jogos ativos',

  // Status indicators
  'Connected': 'Conectado',

  // Skip/Complete messages
  'Onboarding completed': 'Tour concluído',
  'Onboarding skipped': 'Tour pulado',
};